// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3e9Ii","label":"Section_label__2eGqI","contentWrap":"Section_contentWrap__1ONC2","footer":"Section_footer__1Zh0z","footerInner":"Section_footerInner__oxyYM"};